export default class CreateAgencyRoleRequest {
    name = '';
    permissionWorkers = 0;
    permissionCompanies = 0;
    permissionLocations = 0;
    permissionContacts = 0;
    permissionBookings = 0;
    permissionJobs = 0;
    permissionOpportunities = 0;
    permissionPayroll = 0;
    permissionSpecOuts = 0;
    permissionInvoices = 0;
    permissionTimesheets = 0;
    permissionCampaigns = 0;
    permissionMessaging = 0;
    permissionReports = 0;
    permissionActivities = 0;
    permissionCompliance = 0;
    permissionKpis = 0;
    // Agency section
    permissionSettingsAgencyProfile = 0;
    permissionSettingsBranches = 0;
    permissionSettingsRateCards = 0;
    permissionSettingsUniforms = 0;
    permissionSettingsReportingPeriods = 0;
    permissionSettingsKpis = 0;
    // Users & Permissions section
    permissionSettingsUsers = 0;
    permissionSettingsGroups = 0;
    permissionSettingsRoles = 0;
    // Communication section
    permissionSettingsEmailTemplates = 0;
    permissionSettingsConversationTopics = 0;
    permissionSettingsBusinessHours = 0;
    // Categories section
    permissionSettingsNoteCategories = 0;
    permissionSettingsActivityCategories = 0;
    // Work Types section
    permissionSettingsIndustries = 0;
    permissionSettingsLocationTypes = 0;
    permissionSettingsSkills = 0;
    permissionSettingsQualifications = 0;
    permissionSettingsPositions = 0;
    // Integrations section
    permissionSettingsIntegrations = 0;
    permissionSettingsMobileApp = 0;
    // Sales / Pipeline section
    permissionSettingsOpportunitySources = 0;
    permissionSettingsOpportunityLostReasons = 0;
    // Other standalone settings pages
    permissionSettingsFaq = 0;
}
